import { Mail, ArrowUpRight } from "lucide-react";
import { useLang, CONTACT_EMAILS } from "@/lib/i18n";
import { Reveal, Eyebrow } from "./Reveal";
import { ContactForm } from "./ContactForm";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-32">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[520px] overflow-hidden">
        <div className="absolute left-1/2 top-[-200px] h-[600px] w-[1100px] -translate-x-1/2 rounded-full bg-[#2F7BFF]/15 blur-[120px]" />
        <div className="streak left-[-5%] top-[38%]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="max-w-3xl text-white">
          <Eyebrow light>{c.eyebrow}</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-[44px] lg:leading-[1.1]">{c.title}</h2>
        </Reveal>
        <Reveal delay={120} className="mt-12 grid grid-cols-1 overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] shadow-[0_40px_80px_-40px_rgba(0,0,0,.7)] lg:grid-cols-[1fr_1.25fr]">
          <div className="min-w-0 bg-white/[0.03] p-7 sm:p-10">
            <div className="space-y-4 text-base leading-relaxed text-slate-300">
              {c.p.map((p) => <p key={p}>{p}</p>)}
            </div>
            <p className="mt-6 font-display text-xl font-bold text-white">{c.closing}</p>
            <div className="mt-8 space-y-3">
              {Object.entries(CONTACT_EMAILS).map(([k, email]) => (
                <a key={k} href={`mailto:${email}`} data-testid={`contact-email-${k}`} className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4 transition-[border-color,transform] hover:-translate-y-0.5 hover:border-[#2F7BFF]">
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#2F7BFF]/15 text-[#7FB2FF] transition-colors group-hover:bg-[#2F7BFF] group-hover:text-white"><Mail className="h-5 w-5" /></span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">{c.emailLabels[k]}</span>
                    <span className="block truncate font-semibold text-white">{email}</span>
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-slate-400 transition-colors group-hover:text-[#2F7BFF]" />
                </a>
              ))}
            </div>
          </div>
          <div className="min-w-0 p-7 sm:p-10"><ContactForm /></div>
        </Reveal>
      </div>
    </section>
  );
};
